export enum DefaultVendorCostState {
  CONTACT_SALES_REP = 'contact_sales_rep',
  INVENTORY_ONLY = 'inventory_only',
  LEGACY = 'legacy',
  PRICED = 'priced',
  UNAVAILABLE = 'unavailable',
}
